import { ISavedStateComment } from '@shared/user-state/comments/SavedStateCommentsService';
import { MapWrapper } from '@openlayers/MapWrapper';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import * as olStyle from 'ol/style';
import Feature from 'ol/Feature';
import { Point as OlPoint } from 'ol/geom';
import { latLonToEN } from '@openlayers/ol-utils';
import { VectorImage } from 'ol/layer';
import VectorImageLayer from 'ol/layer/VectorImage';

/*
 * Displays page state comment drawings as 2d map overlays pinned to location
 * allows moving of the camera without clearing the drawings
 */
export class DrawingsDisplayOpenlayers implements IDrawingsDisplay {
    public enabled = true;
    private comments: ISavedStateComment[] = [];
    private layerId = 'page-view-comments';

    layerSource: VectorSource = null;
    layer: any = null;

    constructor(
        private mapWrapper: MapWrapper
    ) {
        const existingLayer = this.mapWrapper.getLayerById(this.layerId);
        if (existingLayer) {
            this.layer = existingLayer;
            this.layerSource = existingLayer.getSource();
        } else {
            this.layerSource = new VectorSource({
                attributions: '',
                features: [],
                useSpatialIndex: true,
            });

            this.layer = new VectorImageLayer({
                source: this.layerSource,
                className: 'saved-state-drawings' // this is important so that drawings are excluded from thumbnail
            });

            this.layer.set('id', this.layerId);
            mapWrapper.addLayer(this.layer, 9999, this.layerId);
        }

        this.initialZoom = this.mapWrapper.getZoom();
    }

    initialZoom = 1;

    destroy = () => {
        this.mapWrapper.removeLayerById(this.layerId);
        this.layer.setMap(null);
        this.layerSource.clear();
    }

    drawDrawings = () => {
        if (!this.enabled) {
            this.comments.forEach(c => c.canvasVisible = false);
        }
        this.layerSource.clear();

        const zoom = this.mapWrapper.getZoom(); // max zoom in = 27, max zoom out = 3
        const diff = zoom - this.initialZoom;
        const scale = Math.pow(2, diff);

        this.comments.forEach(comment => {
            if (comment.canvasVisible && comment.lat && comment.lon) {
                try {
                    const feature = new Feature({
                        geometry: new OlPoint(latLonToEN(comment.lat, comment.lon))
                    });

                    const featureStyle = new olStyle.Style({
                        image: new olStyle.Icon({
                            src: comment.canvas,
                            anchor: [0.5, 0.5],
                            scale
                        })
                    });

                    feature.setId(comment.id);
                    feature.setStyle(featureStyle);

                    this.layerSource.addFeature(feature);
                } catch { }
            }
        });
    };

    setComments(value: ISavedStateComment[]) {
        this.layerSource.clear();
        this.comments = value;
    }

    hideDrawings = () => {
        this.comments.forEach(c => c.canvasVisible = false);
        this.drawDrawings();
    };

    hideComment(id: number) {
        this.setCommentVisible(id, false);
    }

    showComment(id: number) {
        this.setCommentVisible(id, true);
    }

    private setCommentVisible = (id: number, state: boolean) => {
        if (!this.enabled) return;

        const comment = this.comments.find(c => c.id === id);
        if (!comment) {
            console.warn('no comment with id found', id);
            return;
        }

        comment.canvasVisible = state;
        this.drawDrawings();
    };
}
